import React, { Fragment } from 'react';

import AccordionItem from '../custom-visual-inspection/accordion-item';
import CustomNewItem from '../custom-general/custom-new-item';
import TOFDScanPlan from '../../forms/custom-tofd/tofdScanPlan';

import { PDFImageProps } from '../../../utils/models';

export interface TOFDScanPlanItem {
    id: number;
    wallThickness: number;
    bevelAngle: number;
    weldBevelShape: string;
    weldCondition: string;
    scanType: string;
    materialType: string;
    probeAngle: string;
    probeSerialNumber: string;
    calibrationBlockThickness: number;
    scanSide: string;
    equipmentModal: string;
    equipmentSerialNumber: string;
    equipmentCalibrationDueDate: Date;
    referenceDB: number;
    inspectionDate: Date;
    images: PDFImageProps[];
}

interface Props {
    tofdScanPlanItems: TOFDScanPlanItem[];
	onDataChange: (items: TOFDScanPlanItem[]) => void;
}

const TOFDScanPlanItems: React.FC<Props> = (props) => {
	const handleAddItem = (item: TOFDScanPlanItem) => {
        const newItem = { 
            ...item,
            id: props.tofdScanPlanItems.length + 1 
        };

		props.onDataChange([...props.tofdScanPlanItems, newItem]);
	};

	const handleDeleteItem = (item: TOFDScanPlanItem): void => {
		const newAnomalyItems = props.tofdScanPlanItems.filter((tofdItem) => tofdItem.id !== item.id);
		props.onDataChange(newAnomalyItems);
	};

	const handleEditItem = (originalItem: TOFDScanPlanItem, updatedItem: TOFDScanPlanItem): void => {
        const updatedItems = props.tofdScanPlanItems.map((tofdItem) => tofdItem.id === originalItem.id ? updatedItem : tofdItem);
		props.onDataChange(updatedItems);
	};

	return (
		<Fragment>
            <CustomNewItem label='Add New TOFD Scan Plan'>
                <TOFDScanPlan onSave={handleAddItem} />
            </CustomNewItem>

			<div className="divider my-4"></div>

            {props.tofdScanPlanItems.map((tofdItem) => (
                <AccordionItem key={tofdItem.id} title={`#${tofdItem.id}`} isActive>
                    <TOFDScanPlan
                        initialTOFDItem={tofdItem}
                        onDeleteItem={() => handleDeleteItem(tofdItem)}
                        onSave={(updatedItem: TOFDScanPlanItem) => handleEditItem(tofdItem, updatedItem)} 
                    />
                </AccordionItem>
            ))}
		</Fragment>
	);
};

export default TOFDScanPlanItems;